<script lang="ts" setup>
interface ButtonProps {
  type?:
    | "is-ghost"
    | "is-link"
    | "is-white"
    | "is-primary"
    | "is-secondary"
    | "is-light"
    | "is-dark";
  size?: "is-default" | "is-small" | "is-medium" | "is-large";
  rounded?: boolean;
  inverted?: boolean;
  outlined?: boolean;
  disabled?: boolean;
  loading?: boolean;
  iconLeft?: string;
  iconRight?: string;
  tooltipRight?: boolean;
  iconLeftSlot?: boolean;
  expanded?: boolean;
  iconPack?: string;
  // Render as a link instead of a <button> (e.g. "router-link"/"a") — lets
  // NuxtLink-style "button-shaped links" (create/cancel actions) reuse this
  // component instead of hand-writing `class="button is-..."` on a NuxtLink.
  tag?: string;
  to?: string;
}

const {
  type,
  size,
  rounded = true,
  inverted = false,
  outlined = false,
  disabled = false,
  loading = false,
  iconLeft,
  iconRight,
  tooltipRight = false,
  iconLeftSlot = false,
  expanded = false,
  iconPack = "fas",
  tag,
  to
} = defineProps<ButtonProps>();
</script>

<template>
  <b-button
    :tag="tag"
    :to="to"
    :type="type"
    :size="size"
    :rounded="rounded"
    :inverted="inverted"
    :outlined="outlined"
    :disabled="disabled || undefined"
    :loading="loading"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :expanded="expanded"
    :icon-pack="iconPack"
  >
    <div class="main-content-button">
      <div v-if="iconLeftSlot" class="left_icon">
        <slot name="left_icon" />
      </div>
      <slot name="default" />
      <slot v-if="tooltipRight" name="tooltipRight" />
    </div>
  </b-button>
</template>

<style lang="scss" scoped>
.main-content-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 8px;
  font-family: $family-inter;
  font-size: inherit;
  line-height: inherit;

  .left_icon {
    height: 16px;
    width: 16px;
  }
}

.is-default {
  padding: 7px 16px;
  gap: 12px;
  font-style: normal;
  line-height: 25.6px;
}
.is-small {
  padding: 5px 12px;
  gap: 9px;
  font-style: normal;
  line-height: 20px;
}
.is-medium {
  padding: 9px 20px;
  gap: 15px;

  font-style: normal;
  line-height: 32px;
}
.is-large {
  padding: 11px 24px;
  gap: 18px;
  font-style: normal;
  line-height: 38.4px;
}
</style>
